import styled from 'styled-components';

export const CareerImg = styled.div`
  padding-bottom: 6.66vw;
  padding-top: ${ $props => $props.first ? '85vh' : '8.33vw'};
  padding-left: ${ $props => $props.left ? $props.left : '' };
  
`